import DatePeriod from '@framework/ui/Organisms/Filters/FiltersPanel/DatePeriod';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { CFR_ARTICLES } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/constants';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';

interface ISidebarDatePeriodProps {
  onDateFromChange: (dateFrom:Date) => void,
  onDateToChange: (dateTo:Date) => void,
}

const SidebarDatePeriod = (props: ISidebarDatePeriodProps) => {
  const { state: { dateFromMin, dateToMax } } = useArticlesFilterContext();
  const { filters } = useFiltersContext();

  const isFilterExists = CFR_ARTICLES in filters;
  const dateFrom = isFilterExists ? filters[CFR_ARTICLES].dateFrom : null;
  const dateTo = isFilterExists ? filters[CFR_ARTICLES].dateTo : null;

  return (
    <DatePeriod
      dateFromMin={ dateFromMin }
      dateToMax={ dateToMax }
      dateFrom={ dateFrom }
      dateTo={ dateTo }
      { ...props }
    />
  );
};

export default SidebarDatePeriod;
